import React from 'react';

import One from '../../../../assets/simplified-lobby-numbers/1.svg';
import Ten from '../../../../assets/simplified-lobby-numbers/10.svg';
import Two from '../../../../assets/simplified-lobby-numbers/2.svg';
import Three from '../../../../assets/simplified-lobby-numbers/3.svg';
import Four from '../../../../assets/simplified-lobby-numbers/4.svg';
import Five from '../../../../assets/simplified-lobby-numbers/5.svg';
import Six from '../../../../assets/simplified-lobby-numbers/6.svg';
import Seven from '../../../../assets/simplified-lobby-numbers/7.svg';
import Eight from '../../../../assets/simplified-lobby-numbers/8.svg';
import Nine from '../../../../assets/simplified-lobby-numbers/9.svg';

import styles from './Number.scss';

const numbers = [One, Two, Three, Four, Five, Six, Seven, Eight, Nine, Ten];

export interface Props {
  index: number;
}

const Number: React.FC<Props> = ({ index }) => (
  <div className={styles.numberWrapper}>{React.createElement(numbers[index])}</div>
);

export default Number;
